export { SmartLink } from './smart-link';
export { getLinkType } from './smart-link.utils';
export type {
  SmartLinkProps,
  LinkResolver,
  LinkResolverProps,
  LinkType,
} from './smart-link.types';
